import React from 'react';

import { useAuth } from '../../../../../auth';
import styles from '../styles.module.css';

export const Username = () => {
  const { user } = useAuth();

  return <div className={styles.userName}>{user?.name}</div>;
};
